import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import servicesBoxStyles from './servicesBoxStyles.module.scss';
import { actions } from './../../../state';
import Boxes from './../boxes/boxes';
import { InputElement } from './../../../components';
import { formattedDevices } from '../locations.utils';

const TyreBlackener = ({ dispatch, data, requestError }) => {
  const [values, setValues] = useState({
    tyreBlackenerPrice: data !== null ? data.options[0].price / 100 : '',
    tyreBlackenerDuration: data !== null ? data.time : '',
  });

  const [devices, setBoxesValues] = useState(data === null ? [] : data.devices);

  const handleInputChange = ({ target: { name, value } }) => {
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    const options = [
      {
        type: 701,
        price: values.tyreBlackenerPrice * 100,
      },
    ];

    const data = {
      time: values.tyreBlackenerDuration,
      options,
      devices: formattedDevices(devices),
    };
    dispatch(actions.addEditServices.pushTyreBlackenerAction(data));
  });

  const handleStateFromBoxes = x => {
    setBoxesValues(x);
  };

  return (
    <div className={servicesBoxStyles.mainContainer}>
      <table className={servicesBoxStyles.container}>
        <thead>
          <tr>
            <th>Pavadinimas</th>
            <th>Kaina su PVM (EUR)</th>
            <th>Trukmė (min)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Padangų juodinimo paslaugos</td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="tyreBlackenerPrice"
                type="number"
                onChange={handleInputChange}
                value={values.tyreBlackenerPrice}
                invalid={requestError && !values.tyreBlackenerPrice}
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </td>
            <td className={servicesBoxStyles.pricePlanInput}>
              <InputElement
                name="tyreBlackenerDuration"
                type="number"
                onChange={handleInputChange}
                value={values.tyreBlackenerDuration}
                invalid={requestError && !values.tyreBlackenerDuration}
                placeholder="0"
                min="0"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <Boxes
        handleStateFromBoxes={handleStateFromBoxes}
        devices={data === null ? [] : data.devices}
        location="tyre_blackener"
        requestError={requestError}
      />
    </div>
  );
};

TyreBlackener.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.shape({
    devices: PropTypes.array.isRequired,
    id: PropTypes.number.isRequired,
    options: PropTypes.array.isRequired,
    status: PropTypes.number.isRequired,
    type: PropTypes.number.isRequired,
  }),
};

export default connect()(TyreBlackener);
